<template>
  <div class="salesRelated">
    <div class="performanceTargets_box">
      <div class="topBox">
        <div class="topBox_font">业绩目标</div>
        <div class="progress">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="我的" name="my">
              <div id="semicircle"><span class="progress"><el-progress type="dashboard" :percentage="percentage" :color="colors" :show-text="false" width="180" stroke-width="16"></el-progress></span></div>
              <span class="percentage">114514%</span>
              <div class="target">
                <div>目标:</div>
                <div style="font-weight: 600; color: #2d8cf0">1,000.00</div>
              </div>
              <div class="completed">
                <div>已完成:</div>
                <div style="font-weight: 600; color: #2d8cf0">560.00</div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="战队" name="team">
              <div id="clan"><span class="progress"><el-progress type="dashboard" :percentage="percentage" :color="colors" :show-text="false" width="180" stroke-width="16"></el-progress></span></div>
              <span class="percentage">114514%</span>
              <div class="target">
                <div>目标:</div>
                <div style="font-weight: 600; color: #2d8cf0">1,000.00</div>
              </div>
              <div class="completed">
                <div>已完成:</div>
                <div style="font-weight: 600; color: #2d8cf0">560.00</div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>

    </div>
    <div class="salesFunnel_box">
      <div class="topBox1">
        <span class="topBox1_font">销售漏斗</span>
        <select class="topBox1_select">
          <option>总部</option>
          <option>分部</option>
          <option>中分部</option>
          <option>小分部</option>
        </select>
        <input type="date" class="topBox1_date">
      </div>
      <div id="salesFunnel">
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  data() {
    return {
      activeName: 'my'
    };
  },
  computed: {},
  mounted() {
    this.getFunnel();
  },
  created() {
  },
  methods: {
    getFunnel() {
      let chartDom = document.getElementById('salesFunnel');
      let myChart = echarts.init(chartDom);
      let option;
      option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c}%'
        },
        toolbox: {
          feature: {
            dataView: {readOnly: false},
            restore: {},
            saveAsImage: {}
          }
        },
        series: [
          {
            name: '',
            type: 'funnel',
            left: '10%',
            top: 60,
            bottom: 60,
            width: '80%',
            min: 0,
            max: 100,
            minSize: '0%',
            maxSize: '100%',
            sort: 'descending',
            gap: 2,
            label: {
              // show: true,
              position: 'inside'
            },
            labelLine: {
              length: 10,
              lineStyle: {
                width: 1,
                type: 'solid'
              }
            },
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 1
            },
            emphasis: {
              label: {
                fontSize: 20
              }
            },
            data: [
              {value: 69, name: '初步洽谈'},
              {value: 18, name: '意向确定'},
              {value: 6, name: '方案/报价'},
              {value: 2, name: '谈判审核'},
              {value: 0, name: '赢单'},
              {value: 1, name: '输单'}
            ]
          }
        ]
      };

      option && myChart.setOption(option);

    }
  }
};
</script>

<style scoped="scoped" lang="scss">
.salesRelated {
  width: 1648px;
  height: 300px;
  background-color: rgba(255, 255, 255, 0.5);
  margin-bottom: 20px;
}

.salesFunnel_box {
  background-color: rgba(255, 255, 255, 0.5);
  float: left;
  width: 49%;
  height: 300px;

  .topBox1 {
    position: relative;
    width: 100%;
    height: 22px;

    .topBox1_select {
      position: absolute;
      top: 12px;
      right: 158px;
      width: 90px;
      border: 1px solid #cecece;
      border-radius: 3px;
    }

    .topBox1_date {
      position: absolute;
      top: 12px;
      right: 50px;
      width: 90px;
      height: 21px;
      border: 1px solid #cecece;
      border-radius: 3px;
    }

    .topBox1_font {
      display: inline-block;
      position: absolute;
      top: 12px;
      left: 20px;
      font-weight: 600;
      width: 140px;
    }
  }

  #salesFunnel {
    width: 100%;
    height: 278px;
    margin-top: 30px;
  }

  .annulus_bottom {
    width: 100%;
    height: 50%;

    .annulus_bottom4 {
      position: relative;
      margin: 0 58px;
      float: left;
    }
  }
}

.performanceTargets_box {
  background-color: rgba(255, 255, 255, 0.5);
  float: left;
  width: 48%;
  height: 300px;
  margin-right: 36px;

  .topBox {
    position: relative;
    width: 100%;
    height: 22px;
    width: 100%;
    height: 22px;

    .progress {
      width: 96%;
      position: absolute;
      top: 26px;
      left: 20px;

      .percentage {
        position: absolute;
        top: 100px;
        left: 170px;
        color: #2d8cf0;
        font-size: 16px;
        font-weight: 600;
      }
      .target {
        position: absolute;
        top: 36px;
        left: 400px;
      }
      .completed {
        position: absolute;
        top: 110px;
        left: 400px;
      }
      #semicircle {
        width: 100%;
        height: 300px;
        .progress {
          position: absolute;
          top: 12px;
          left: 109px;
        }
      }
      #clan {
        width: 100%;
        height: 300px;
        .progress {
          position: absolute;
          top: 12px;
          left: 109px;
        }
      }
    }

    .topBox_font {
      position: absolute;
      top: 12px;
      left: 20px;
      font-weight: 600;
      width: 140px;
    }

  }

}
</style>
